import { mapActions } from "vuex"
export default {
    methods: {
        ...mapActions('message',['getMessageLackAPI']),
        ...mapActions('login', ['depositConfirmAPI']),
        // 判断是否短信不足
        async getMessageLackFn(){
            // let messageLackStamp = parseInt(localStorage.getItem('messageLackStamp') || 0) 
            // let nowStamp = +new Date()
            // let gapTime = 0.1*60*1000 // 间隔时间，分钟
            // if(nowStamp-messageLackStamp < gapTime){
            //     return
            // }else{
            //     localStorage.setItem('messageLackStamp',JSON.stringify(nowStamp))
            // }
            let res = await this.getMessageLackAPI()
            if(res.is_remind){
                this.$confirm(res.remind_content, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '去充值',
                    cancelButtonText: '取消'
                })
                .then(() => {
                    this.$router.push({
                        path: this.staticPath + "msmService",
                        query: {
                            type: res.type //1=购课;2=转私;3=语音
                        }
                    })
                })
            }
        },
        // 判断是否同意登录时的协议
        async handleAgreement(){
            let res = await this.depositConfirmAPI({
                type: 1,
                agreement_id: 1
            })
            if(res.is_confirm) return
            this.removeStroage()
            this.$router.replace(this.staticPath + 'login')
        },
        removeStroage() {
            localStorage.removeItem('token')
            localStorage.removeItem('name')
            localStorage.removeItem('avatar_url')
            localStorage.removeItem('breadCrumbList')
            localStorage.removeItem('institution')
            localStorage.removeItem('platPath')
            localStorage.removeItem('wattingTime')
            localStorage.removeItem('desc')
        },
    }
}